import { onUseQueries } from './onUseQueries'

interface IQueries {
    sortindFiled?: string | null
    search?: ISearch | null
    filters?: {
        list: IFilter[]
        separator: string
    }
    limit?: number
    offset?: number
    count?: boolean
}

const onHandleFilters = (params: IFilter[], separator: string) => {
    const handledParams = params.map(({ field, operator, value }) => `${field} ${operator} '${value}'`)
    return `${handledParams.join(` ${separator} `)}`
}

export const onUseOdataQueries = (queries: IQueries) => {
    const { search, filters, limit = null, offset = null, count = false, sortindFiled } = queries
    const searchFilter = search
        ? `${search.query
              .map(({ key, value }) => `contains(tolower(${key}),'${value.toLowerCase()}')`)
              .join(` ${search.operator} `)}`
        : null

    const paramsFilter = filters
        ? onHandleFilters(
              filters.list.filter((f) => f.value !== null),
              filters.separator
          )
        : null
    const filter: (string | null)[] = [paramsFilter, searchFilter]
    const resopnse: Record<string, string | number | boolean | null> = {
        $filter: filter.filter((f) => f).join(' and '),
        $top: limit,
        $skip: offset && limit ? offset * limit : null,
        $count: count,
        $orderby: sortindFiled ? `${sortindFiled}` : null
    }
    return onUseQueries(resopnse)
}

interface ISearch {
    operator: 'and' | 'or'
    query: ISearchQuery[]
}

interface ISearchQuery {
    key: string
    value: string
}

interface IFilter {
    field: string
    operator: 'eq' | 'ne'
    value: string | boolean | null
}
